/** Enhance native Shopify forms; never replace their POST or infer a success. */
function setupForm(form) {
  if (form.dataset.etolieValidationReady) return;
  form.dataset.etolieValidationReady = 'true';
  let focusQueued = false;

  function errorFor(field, create = false) {
    const id = `${field.id}-validation`;
    let error = document.getElementById(id);
    if (!error && create) {
      error = document.createElement('p');
      error.id = id;
      error.className = 'etolie-field-error';
      error.setAttribute('role', 'alert');
      if (form.matches('.etolie-foot__newsletter-form')) form.append(error);
      else field.after(error);
    }
    return error;
  }

  function showError(field) {
    if (!field.id || !field.validity || field.validity.valid) return;
    const error = errorFor(field, true);
    error.hidden = false;
    error.textContent = field.type === 'email'
      ? window.etolieT('Wpisz poprawny adres e-mail.')
      : field.validity.valueMissing ? window.etolieT("Uzupełnij to pole.") : field.validationMessage;
    field.setAttribute('aria-invalid', 'true');
    const describedBy = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
    describedBy.add(error.id);
    field.setAttribute('aria-describedby', [...describedBy].join(' '));
  }

  form.addEventListener('invalid', (event) => {
    const field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement) || !field.id) return;
    // Native constraints still cancel the POST. A local inline message replaces
    // the browser bubble and leaves every entered value in place.
    event.preventDefault();
    showError(field);
    if (!focusQueued) {
      focusQueued = true;
      queueMicrotask(() => {
        focusQueued = false;
        const first = [...form.elements].find((input) => input.willValidate && !input.validity.valid);
        first?.focus();
      });
    }
  }, true);

  form.addEventListener('input', (event) => {
    const field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement) || !field.id) return;
    const error = errorFor(field);
    if (!error) return;
    if (!field.validity.valid) {
      showError(field);
      return;
    }
    error.hidden = true;
    field.removeAttribute('aria-invalid');
    const describedBy = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== error.id);
    if (describedBy.length) field.setAttribute('aria-describedby', describedBy.join(' '));
    else field.removeAttribute('aria-describedby');
  });

  // Only Liquid emits this marker after Shopify returns a result. Respect the
  // POST anchor so a second form in the footer cannot steal the contact result.
  const result = form.querySelector('[data-etolie-form-result]');
  let anchor = window.location.hash.slice(1);
  try { anchor = decodeURIComponent(anchor); } catch { /* Keep the literal hash. */ }
  if (result && (anchor === form.id || anchor === result.id || (!anchor && result === document.querySelector('[data-etolie-form-result]')))) {
    result.focus({ preventScroll: false });
  }
}

function setupForms(scope = document) {
  scope.querySelectorAll('[data-etolie-form] form').forEach(setupForm);
}
setupForms();
document.addEventListener('shopify:section:load', (event) => setupForms(event.target));
